module.exports = __webpack_public_path__ + "img/ic_export-completed-warning.72ac0dac.svg";